import { usePermanentAppState } from '@ms/yammer-modules-townhall-event';
import { getEventBroadcastDataFromPath } from '@ms/yammer-web-support/dist/location';
import type { FC } from 'react';
import React, { useEffect } from 'react';

import App from '../App';
import AppLiveEvent from '../AppLiveEvent';

const Main: FC = () => {
  const hasBroadcastData = getEventBroadcastDataFromPath(window.location.pathname) !== undefined;
  const { permanentApp, setPermanentApp } = usePermanentAppState();

  useEffect(() => {
    if (!permanentApp) {
      setPermanentApp(hasBroadcastData ? 'AppLiveEvent' : 'App');
    }
  }, [hasBroadcastData, permanentApp, setPermanentApp]);

  if (permanentApp === 'AppLiveEvent') {
    return <AppLiveEvent />;
  }

  if (permanentApp === 'App') {
    return <App />;
  }

  return null;
};

export default Main;
